import React from 'react'
import { Box, Grid } from 'ui/acro'
import { LargeButton, PageHeader, PageLayout, SearchBox } from '../__shared__'

export const Main = ({ categoryList }) => {
  let content

  if (categoryList) {
    content = categoryList.map(({ label, categorySlug, enabled }) => (
      <LargeButton
        key={categorySlug}
        label={label}
        disabled={!enabled}
        href={`/support/${categorySlug}`}
      />
    ))
  }

  return (
    <>
      <Box
        py={['30px', null, null, null]}
        pt={[null, null, '60px']}
        backgroundColor='#FAFAFA'
        textAlign='center'
      >
        <PageLayout>
          <PageHeader
            title={'FAQ'}
            subTitle='How Can We Help?'
            maxWidth='905px'
          />
          <SearchBox />
        </PageLayout>
      </Box>
      <PageLayout>
        <Grid
          gridTemplateColumns={['50% 50%', '25% 25% 25% 25%']}
          gridTemplateRows={['50% 50%']}
          gridRowGap={['10px', '15px']}
          gridColumnGap={['16px', '22px']}
          justifyContent={'center'}
          alignContent={'center'}
          margin='auto'
          py={['40px', '40px', '40px', '58px']}
          px={['20px', null, null, null]}
        >
          {content}
        </Grid>
      </PageLayout>
    </>
  )
}

export default Main
